import React, { Fragment, useState } from "react"
import Button from "react-bootstrap/lib/Button"
import AlertModalWithBody from "../../../ui-components/AlertModalWithBody";

// ----------------------------------------------------------------------------

function ActionButton({ action, orderId, handleAction }) {
  // -------------------------------------
  // Props destructuring
  // -------------------------------------

  const { title, enabled, danger, message, name } = action;

  // -------------------------------------
  // Hooks (e.g. useState, useMemo ...)
  // -------------------------------------

  const [showModal, setShowModal] = useState(false);

  // -------------------------------------
  // Effects
  // -------------------------------------

  // -------------------------------------
  // Component functions
  // -------------------------------------

  // -------------------------------------
  // Component local variables
  // -------------------------------------

  const disabled = !enabled;
  const style = danger ? "danger" : "primary"
  const onSecondAction = enabled ? () => setShowModal(false) : false
  const confirmLabel = enabled ? title : I18n.t("close")

  // -------------------------------------
  return (
    <div>
      <Fragment>
        <AlertModalWithBody
          show={showModal}
          onHide={() => setShowModal(false)}
          onConfirm={() => {
            setShowModal(false);
            if (enabled) { handleAction(name) }
          }}
          title={title}
          secondActionLabel={I18n.t("close")}
          onSecondAction={onSecondAction}
          closeLabel={confirmLabel}
          closeBsStyle={enabled ? "primary" : "default"}
          isTiny={true}>
          <div>{message}</div>
        </AlertModalWithBody>

        <Button bsStyle={style}
                onClick={() => setShowModal(true)}>
          {title}
        </Button>
      </Fragment>
    </div>
  )
}

// ----------------------------------------------------------------------------

export default ActionButton
